import { cellForced } from '../config'
import { TableProps } from '../util/default-props'
import {
  getOptionProps,
  getKey,
  getClass,
  getStyle,
  getEvents
} from '../util/props-util'
import VcTable from './vc-table'

export default {
  name: 'SyFormatTable',
  components: {
    VcTable
  },
  props: { ...TableProps },
  methods: {
    defaultRowCell () {
      return params => {
        return cellForced.default.rowCell(this.$createElement, params)
      }
    },
    normalize ({ default: elements = [] }) {
      const columns = []
      elements.forEach(element => {
        if (!element.tag) {
          return
        }
        const key = getKey(element)
        const style = getStyle(element)
        const cls = getClass(element)
        const props = getOptionProps(element)
        const events = getEvents(element)
        const listeners = {}
        Object.keys(events).forEach(e => {
          listeners[e] = events[e]
        })
        const column = { ...props, style, class: cls, ...listeners }
        if (key) {
          column.key = key
        }
        const {
          default: customRender,
          header: headerRender,
          expand: expandRender
        } = element?.data?.scopedSlots || {}
        column.customRender = customRender || this.defaultRowCell()
        column.title = headerRender || column.title
        column.slots = {
          title: headerRender || column.title,
          customRender: customRender || this.defaultRowCell()
        }
        if (expandRender) {
          column.slots.customRender = expandRender
        }
        columns.push(column)
      })
      return columns
    },
    updateColumns (cols = []) {
      const columns = []
      const { $scopedSlots } = this
      const $slots = this.$slots.default[0]
      cols.forEach(col => {
        const { slots = {}, scopedSlots = {}, ...restProps } = col
        const column = {
          ...restProps
        }
        Object.keys(slots).forEach(key => {
          const name = slots[key]
          if (column[key] === undefined && $slots[name]) {
            column[key] =
              $slots[name].length === 1 ? $slots[name][0] : $slots[name]
          }
        })
        Object.keys(scopedSlots).forEach(key => {
          const name = scopedSlots[key]
          if (column[key] === undefined && $scopedSlots[name]) {
            column[key] = $scopedSlots[name]
          }
        })
        // 没有自定义走默认
        if (!column.customRender) {
          column.customRender = this.defaultRowCell()
        }
        columns.push(column)
      })
      return columns
    }
  },
  render (h) {
    const { columns, $slots, $props } = this
    const cols = columns.length
      ? this.updateColumns(columns)
      : this.normalize($slots.default[0])
    if (cols.length === 0) {
      return null
    }
    const tProps = {
      props: {
        ...$props,
        columns: cols
      }
    }
    return <VcTable {...tProps} />
  }
}
